import { Component, inject, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { AuthorizationService } from '../../services/authorization.service';
import { AuthService } from '@auth0/auth0-angular';
import { StateService } from '../../services/state.service';
import { AssetVersionPipe } from '../../pipes/asset-version.pipe';

@Component({
  selector: 'app-workspace-error-screen',
  imports: [AssetVersionPipe],
  templateUrl: './workspace-error-screen.component.html',
  styleUrl: './workspace-error-screen.component.scss'
})
export class WorkspaceErrorScreenComponent implements OnInit {
  public userEmail?: string;
  public userFirstName?: string;
  private authService = inject(AuthService);
  private authorizationService = inject(AuthorizationService);
  ngOnInit(): void {
    const profile = this.authorizationService.userProfile;
    if (profile) {
      this.userEmail = profile.email;
      this.userFirstName = profile.firstName;
      return;
    }
    // No initialized app profile (e.g. the user has no provisioned workspace, so getMyUser
    // failed) — fall back to the Auth0 identity so we can still greet them and show their email.
    this.authService.user$.pipe(take(1)).subscribe(user => {
      this.userEmail = user?.email;
      this.userFirstName = user?.given_name;
    });
  }
  logout() {
    this.authService.logout();
  }
}
